import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

import Select from "react-select";               // <-- new
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import "./LabReport.css"

const sampleOptions = [
  { value: "serum", label: "Serum" },
  { value: "blood", label: "Blood" },
  { value: "whole blood", label: "Whole Blood" },
  { value: "urine", label: "Urine" },
  { value: "feces", label: "Feces" },
  { value: "saliva", label: "Saliva" },
  { value: "sputum", label: "Sputum" },
  { value: "tissue", label: "Tissue" },
  { value: "10 ml EDTA", label: "10 ml EDTA" },
  { value: "CSF", label: "CSF" },
  { value: "Cystic Fluid", label: "Cystic Fluid" },
  { value: "Ear Swab", label: "Ear Swab" },
  { value: "Finger Prick", label: "Finger Prick" },
  { value: "Fluid", label: "Fluid" },
  { value: "Gastric Lavage", label: "Gastric Lavage" },
  { value: "Hair", label: "Hair" },
  { value: "Lavage Fluid", label: "Lavage Fluid" },
  { value: "Nasal Swab", label: "Nasal Swab" },
  { value: "PCR", label: "PCR" },
  { value: "Pleural Fluid", label: "Pleural Fluid" },
  { value: "Semen", label: "Semen" },
  { value: "Seminal Fluid", label: "Seminal Fluid" },
  { value: "Stool", label: "Stool" },
  { value: "Synovial Fluid", label: "Synovial Fluid" },
  { value: "TBD", label: "TBD" },
  { value: "Throat Swab", label: "Throat Swab" },
  { value: "Wound Swab", label: "Wound Swab" },
];

const AddTest = ({ item, onAddDepart }) => {
  const [showImageUpload, setShowImageUpload] = useState(false);
  const [formData, setFormData] = useState({
    cats: [],
    test_id: '',
    test_name: '',
    test_sample_type: '', // will hold the value string (e.g. "blood")
    test_cat: '',
    test_short_name: '',
    test_price: '',
    test_status: 'Active',
    sample: '',
    test_department: '',
    test_interpratation: '',
    test_image: '',
    test_user: '',
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  });
  const [ldata, setLdata] = useState(null);
// ===== Test Department states (MISSING – ADD THIS) =====
const [testDepartments, setTestDepartments] = useState([]);
const [selectedDept, setSelectedDept] = useState(null);
const [showDeptModal, setShowDeptModal] = useState(false);
const [newDeptName, setNewDeptName] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // handler for react-select change
  const handleSampleChange = (selectedOption) => {
    // selectedOption may be null
    setFormData(prev => ({
      ...prev,
      test_sample_type: selectedOption ? selectedOption.value : ''
    }));
  };
// ===== Load Test Departments =====
const loadTestDepartments = async () => {
  try {
    const fd = new FormData();
    fd.append("search_key", "");

    const res = await axios.post(
      AppConst.BASE_URL + AppConst.getTestDepartmentsUrl,
      fd
    );

    if (res.data.status) {
      setTestDepartments(
        res.data.records.map(d => ({
          value: d.test_dept_id,
          label: d.test_dept_name
        }))
      );
    }
  } catch (e) {
    console.error(e);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append('test_id', formData.test_id);
    fd.append('test_name', formData.test_name);
    fd.append('test_sample_type', formData.test_sample_type);
    fd.append('test_cat', formData.test_cat);
    fd.append('test_short_name', formData.test_short_name);
    fd.append('test_price', formData.test_price);
    fd.append('test_status', formData.test_status);
    fd.append('sample', formData.sample);
    fd.append("test_department", formData.test_department);

    fd.append('test_interpratation', formData.test_interpratation);
    fd.append('test_image', formData.test_image || ''); 
    fd.append('test_user', ldata ? ldata.user_id : '');
    // ... rest unchanged
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addTestUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status) {
        setFormData(prev => ({
          ...prev,
          test_id: '',
          test_name: '',
          test_sample_type: '',
          test_cat: '',
          test_short_name: '',
          test_price: '',
          test_status: 'Active',
          sample: '',
          test_interpratation: '',
          test_user: '',
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
        document.getElementById("closeBt45").click();
        onAddDepart();
      } else {
        setFormData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
      }
    } catch (error) {
      setFormData(prev => ({
        ...prev,
        isAlert: true,
        alertMsg: "Failed",
        alertMsgTyp: "danger",
      }));
    }
  };

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      const fd = new FormData();
      fd.append('cat_type', "department");
      fd.append('page_no', "none");
      fd.append('search_key', "");
      fd.append('par_by', "1");
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (response.data.status) {
          const records = response.data.records;
          if (records) {
            setFormData(prev => ({ ...prev, cats: records }));
          }
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      initData();
      loadTestDepartments();
    }

    if (item) {
      setFormData(prev => ({
        ...prev,
        test_id: item.test_id || '',
        test_name: item.test_name || '',
        test_sample_type: item.test_sample_type || '',
        test_cat: item.test_cat || '',
        test_department: item.test_department || '',
        test_short_name: item.test_short_name || '',
        test_price: item.test_price || '',
        test_status: item.test_status || 'Active',
        sample: item.sample || '',
        test_interpratation: item.test_interpratation || '',
        test_image: item.test_image || '',
        test_user: item.test_user || '',
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        test_id: '',
        test_name: '',
        test_sample_type: '',
        test_cat: '',
        test_short_name: '',
        test_price: '',
        test_status: 'Active',
        sample: '',
        test_interpratation: '',
        test_image: '',
        test_user: '',
      }));
    }
  }, [item])
  ;


  // ✅ Reset department when editing a different test
useEffect(() => {
  setSelectedDept(null);
}, [item]);

  useEffect(() => {
    if (formData.test_department && testDepartments.length) {
      const dept = testDepartments.find(
        d => String(d.value) === String(formData.test_department)
      );
      setSelectedDept(dept || null);
    }
  }, [formData.test_department, testDepartments]);
  
  const handleImageUpload = () => {
    setShowImageUpload(prev => !prev);
  };

  // helper to find react-select selected option from value
  const selectedSampleOption = sampleOptions.find(o => o.value === formData.test_sample_type) || null;

  return (
    <div className="modal fade" id="showModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-fullwidth" style={{ maxWidth: "95%", margin: "0 auto" }}>
        <div className="modal-content">
          <div className="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
            <h5 className="modal-title" id="exampleModalLabel">Add Test</h5>
            <button type="button" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" data-bs-dismiss="modal" id="close-modal">Close</button>
          </div>
          <form className="tablelist-form" onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row gy-4 mb-3">
                <div className="col-md-6">
                  <label className="form-label">Test Name</label>
                  <input name="test_name" onChange={handleChange} value={formData.test_name} className="form-control" placeholder="Enter Test Name" type="text" required />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Category</label>
                  <select className="form-control" name="test_cat" onChange={handleChange} value={formData.test_cat} required>
                    <option value="">Category</option>
                    {formData.cats.map((item, index) => (
                      <option key={index} value={item.cat_id}>{item.cat_name}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Short Name</label>
                  <input name="test_short_name" onChange={handleChange} value={formData.test_short_name} className="form-control" placeholder="Enter Short Name" type="text" />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Price</label>
                  <input name="test_price" onChange={handleChange} value={formData.test_price} className="form-control" placeholder="Enter Price" type="text" required />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Status</label>
                  <select className="form-control" name="test_status" onChange={handleChange} value={formData.test_status} required>
                    <option value="Active">Active</option>
                    <option value="Deactive">Inactive</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Sample Type</label>
                  <Select
                    options={sampleOptions}
                    value={selectedSampleOption}
                    onChange={handleSampleChange}
                    isClearable
                    placeholder="Select or search sample type..."
                    // styles prop can be added if you want to tweak appearance
                  />
                </div>
{/* ===== Test Department ===== */}
<div className="col-md-6">
  <label className="form-label d-flex justify-content-between">
    Test Department
    <span
      className="text-primary"
      style={{ cursor: "pointer", fontSize: 13 }}
      onClick={() => setShowDeptModal(true)}
    >
      + Add
    </span>
  </label>

  <Select
    options={testDepartments}
    value={selectedDept}
    onChange={(opt) => {
      setSelectedDept(opt);
      setFormData(prev => ({
        ...prev,
        test_department: opt ? opt.value : ''
      }));
    }}
    isClearable
    placeholder="Select Test Department"
  />
</div>

<div className="col-md-12">
                <label className="form-label">Interpretation / Description / Comments / Note</label>
                  {!showImageUpload && (
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.test_interpratation}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        const fakeEvent = { target: { name: "test_interpratation", value: data } };
                        handleChange(fakeEvent);
                      }}
                    />
                  )}
                  {showImageUpload && (
                    <div className="border p-3 rounded bg-light">
                      <label className="form-label">Select Image:</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const reader = new FileReader();
                          reader.onload = () => {
                            setFormData(prev => ({ ...prev, test_image: reader.result }));
                          };
                          reader.readAsDataURL(file);
                          e.target.value = '';
                        }}
                        className="form-control"
                      />
                    </div>
                  )}

                  {/* preview — always visible when an image is attached */}
                  {formData.test_image && (
                    <div className="mt-2 border rounded p-2 d-inline-block position-relative">
                      <img src={formData.test_image} alt="attached" style={{ maxWidth: 220, maxHeight: 220 }} />
                      <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        style={{ position: 'absolute', top: 4, right: 4 }}
                        onClick={() => setFormData(prev => ({ ...prev, test_image: '' }))}
                      >
                        ✕
                      </button>
                    </div>
                  )}
                </div>

              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between align-items-center">
              <div className="mt-2">
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleImageUpload}>🖼 Upload Image</button>
              </div>

              <div className="hstack gap-2 justify-content-end">
                <button type="button" id="closeBt45" className="btn btn-light" data-bs-dismiss="modal">Close</button>
                {formData.test_id.length > 0
                  ? <button type="submit" className="btn btn-success">Update</button>
                  : <button type="submit" className="btn btn-success">Add</button>}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ===== Add Test Department Modal ===== */}
{showDeptModal && (
  <div className="modal fade show d-block" style={{ background: "#00000088" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5>Add Test Department</h5>
          <button className="btn-close" onClick={() => setShowDeptModal(false)} />
        </div>

        <div className="modal-body">
          <input
            className="form-control"
            placeholder="Department name"
            value={newDeptName}
            onChange={e => setNewDeptName(e.target.value)}
          />
        </div>

        <div className="modal-footer">
          <button className="btn btn-light" onClick={() => setShowDeptModal(false)}>
            Cancel
          </button>

          <button
            className="btn btn-success"
            onClick={async () => {
              if (!newDeptName.trim()) return;

              const fd = new FormData();
              fd.append("test_dept_name", newDeptName);

              const res = await axios.post(
                AppConst.BASE_URL + AppConst.createTestDepartmentUrl,
                fd
              );

              if (res.data.status) {
                const opt = {
                  value: res.data.test_dept_id,
                  label: res.data.test_dept_name
                };
                setTestDepartments(p => [...p, opt]);
                setSelectedDept(opt);
                setFormData(p => ({ ...p, test_department: opt.value }));
                setShowDeptModal(false);
                setNewDeptName("");
              }
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
    
  );
};

export default AddTest;
